import clsx from 'clsx';
import React from 'react';

import UserAvatar, { AvatarSizes } from '@components/User/UserAvatar';
import UserBylines from '@components/User/UserBylines';
import UserProfileLink from '@components/User/UserProfileLink';
import { CommentUser } from '@utils/backend-api/comments';

import styles from './styles.module.scss';

export default function TopicPostAuthor({ author }: { author: CommentUser }) {
  return (
    <div className={clsx(styles.bylineWithHeadshots)}>
      <UserProfileLink user={author}>
        <UserAvatar user={author} grow={false} size={AvatarSizes.Medium} />
      </UserProfileLink>
      <UserBylines user={author} />
    </div>
  );
}
